import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "relative"
};
const _hoisted_2 = ["data-cy", "value", "rows", "id", "disabled", "readonly", "placeholder"];
const _hoisted_3 = {
  key: 0,
  class: "absolute slot-embeed z-10"
};
import LlTooltip from '@/components/LlTooltip.vue';
export default {
  __name: 'LlResizableTextarea',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: 'text-sm'
    },
    info: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      required: false
    },
    rows: {
      type: Number,
      default: 3
    },
    id: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: ''
    },
    labelStyle: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const handleUpdateValue = event => {
      const value = event.target.value;
      emit('update:modelValue', value);
      emit('change', value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("label", {
        class: _normalizeClass(__props.labelClass),
        style: _normalizeStyle(__props.labelStyle)
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _withDirectives(_createVNode(LlTooltip, {
        text: __props.info,
        icon: "help"
      }, null, 8, ["text"]), [[_vShow, __props.info.length]])], 6), _createElementVNode("div", _hoisted_1, [_createElementVNode("textarea", {
        "data-cy": __props.dataCy,
        value: __props.modelValue,
        onInput: handleUpdateValue,
        rows: __props.rows,
        id: __props.id,
        disabled: __props.disabled,
        readonly: __props.readonly,
        placeholder: __props.placeholder,
        class: "resizable-native-textarea border border-solid border-[rgb(var(--v-theme-outline))] hover:border-[rgba(51,51,51,var(--v-control-border-opacity-hover))] read-only:!bg-[rgb(var(--v-theme-readonly-surface))]"
      }, null, 40, _hoisted_2), _ctx.$slots.append ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "append")])) : _createCommentVNode("", true)])], 64);
    };
  }
};